import { AppContext } from "contexts";
import { Path } from "enums";
import { useContext, useState } from "react";
import { redirectTo } from "utils";

const useApi = ({ api, params = {}, handleOwnError = false, modalError = true, pageError }) => {
  const { errorModal, setPageError } = useContext(AppContext);
  const [loading, setLoading] = useState(undefined);
  const [error, setError] = useState(false);
  const [result, setResult] = useState(undefined);

  const showError = (err, retry) => {
    if (pageError) {
      setPageError(true);
    } else {
      if (modalError) {
        errorModal.show({
          onClick: async () => {
            errorModal.close();
            await retry();
          },
        });
      }
    }
    throw err;
  };

  const request = async (p, retry = () => {}) => {
    setLoading(true);
    setError(false);
    const obj = { ...params, ...p };
    try {
      const res = await api(obj);
      setResult(res);
      setLoading(false);

      return res;
    } catch (err) {
      console.error("Error", err);

      err.showError = () => showError(err, retry);

      setError(true);
      setLoading(false);

      // token is invalidated
      if (err.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        redirectTo(Path.Auth);
        return;
      }

      if (handleOwnError) {
        if (typeof handleOwnError === "boolean") {
          throw err;
        } else if (typeof handleOwnError === "object") {
          if (handleOwnError.hasOwnProperty(err.error)) {
            throw err;
          } else {
            return showError(err);
          }
        }
      } else {
        return showError(err);
      }
    }
  };

  return { request, loading, result, error };
};

export default useApi;
